import { Icon } from '@iconify/react';
import { Tooltip } from '@nextui-org/react';
import { RootState } from '@circuitry-ai/doc-data';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';

/* eslint-disable-next-line */
export interface ConversationstarterscardProps {
  data?: string[];
  onHandleClick: (userInput: string) => void;
}

export function Conversationstarterscard(props: Readonly<ConversationstarterscardProps>) {
  const { t } = useTranslation();
  const { data, onHandleClick } = props;
  const { isSocketLoading } = useSelector((state: RootState) => state.chatAdvisorSliceReducer);
  const isStarterDisabled = isSocketLoading;

  const starters = data?.filter((description) => description.trim() !== '') ?? [];

  const containerClassName =
    'flex flex-col gap-3 w-full max-w-[780px] md:flex-row md:flex-nowrap md:gap-2 md:overflow-hidden';

  if (starters.length === 0) {
    return (
      <div className="w-full flex justify-center">
        <div
          className={containerClassName}
          data-testid="conversation-starters-container"
        />
      </div>
    );
  }

  return (
    <div className="w-full flex justify-center px-1">
      <div
        className={containerClassName}
        data-testid="conversation-starters-container"
      >
        {starters.map((description, index) => {
          const label = t(description);
          return (
            <Tooltip key={`conversation-starters-${index + 1}`} content={label} placement="top" delay={300}>
              <button
                type="button"
                id={`conversation-starters-${index + 1}`}
                disabled={isStarterDisabled}
                onClick={() => !isStarterDisabled && onHandleClick(description)}
                className={`flex w-full md:flex-1 min-w-0 items-center gap-1.5 rounded-full border border-default-200 bg-content1 px-3 py-2 text-left text-sm text-foreground transition-colors ${
                  isStarterDisabled
                    ? 'cursor-not-allowed opacity-60'
                    : 'cursor-pointer hover:border-primary/40 hover:bg-content2'
                }`}
              >
                <span className="min-w-0 flex-1 truncate">{label}</span>
                <Icon icon="lucide:arrow-right" width={14} height={14} className="shrink-0 text-default-400" />
              </button>
            </Tooltip>
          );
        })}
      </div>
    </div>
  );
}

export default Conversationstarterscard;
